import { Component, OnInit, NgZone } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { RegisterService } from './register.service';
import { Observable } from 'rxjs/Observable';
import { Store } from '@ngrx/store';
import { AppState, selectAuthState } from 'src/store/reducers';
import { ActivatedRoute } from '@angular/router';
import { User } from '../../core/interfaces/user';
import { NgxSpinnerService } from 'ngx-spinner';
import { toastmessagesService } from "../../core/services/messages/toastmessages.service";
import { NavigationService } from 'src/app/core/services/navigation/navigation.service';
import { DefaultState  } from 'src/store/actions/authenticationActions';
import { Subscription } from 'rxjs/Subscription';
import { CommonService } from '../../../app/core/services/common/common.service';
@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss']
})
export class RegisterComponent implements OnInit, User {
  public name;
  public email;
  signupForm: FormGroup;
  getState: Observable<any>;
  errorMessage: string | null;
  query;
  geometry;
  cities: any = [];
  isPending: boolean = true;
  registerSubscription: Subscription;
  selectedValue;
  constructor(
    private fb: FormBuilder,
    private register: RegisterService, 
    private store: Store<AppState>, 
    private route: ActivatedRoute,
    private spinner: NgxSpinnerService,
    private message: toastmessagesService,
    private navigate: NavigationService,
    private commonService: CommonService
  ) {
   
    
  
    this.signupForm = fb.group(
      RegisterService.formFields()
    );
  }

  ngOnInit() {
  
  }


  signUp() {
    if (this.signupForm.dirty && this.signupForm.valid) {
      this.spinner.show();
      const userObject: User = {
        email: this.retrieveData("email"),
        password: this.retrieveData("password"),
        first_name : this.retrieveData('first_name'),
        last_name : this.retrieveData('last_name')
      };
      
      console.log(userObject);
      this.register.signUp(userObject).subscribe((succ) => {
        if(succ){
          this.spinner.hide();
          this.navigate.navigateTo('/login');
          this.commonService.getTranslationResponse('successToastr', 'SUCCESSFULLY REGISTERED');
        }else{
          this.spinner.hide()
          this.commonService.getTranslationResponse('errorToastr',  succ.error[Object.keys(succ.error)[0]][0]);
        }
      });
    }
  }

  retrieveData(key) {
    return this.signupForm.value[key];
  }
}
